import { render, staticRenderFns } from "./timeChuli.vue?vue&type=template&id=46f8884e&scoped=true"
import script from "./timeChuli.vue?vue&type=script&lang=js"
export * from "./timeChuli.vue?vue&type=script&lang=js"
import style0 from "./timeChuli.vue?vue&type=style&index=0&id=46f8884e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f8884e",
  null
  
)

export default component.exports